'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { forwardRef, lazy, memo, Suspense } from 'react';
import { useTheme } from 'styled-components';
import HdArrow from './arrow';
import { ButtonContainer } from './styles';
import useButtonProps from './use-button-props';
import ButtonWrapper from './wrapper';
const Spin = lazy(() => import('../spin'));
const Button = memo(forwardRef((props, ref) => {
    const theme = useTheme();
    const dataProps = Object.fromEntries(Object.entries(props).filter(([key]) => key.startsWith('data-')));
    const { currentProps, defaultProps } = useButtonProps(props);
    const { className, children, headingIcon, trailingIcon, withArrowLeft, withArrowRight, disabled, size, loading, handleClick, shape } = defaultProps, buttonProps = __rest(defaultProps, ["className", "children", "headingIcon", "trailingIcon", "withArrowLeft", "withArrowRight", "disabled", "size", "loading", "handleClick", "shape"]);
    const classes = classNames('hd-button', className);
    return (_jsx(ButtonWrapper, Object.assign({}, props, { children: _jsxs(ButtonContainer, Object.assign({ ref: ref }, currentProps, { className: classes, onClick: props.onClick ? handleClick : undefined, disabled: loading || disabled, "$withArrow": withArrowLeft || withArrowRight, "$size": size, "$shape": shape }, dataProps, buttonProps, { children: [!!headingIcon && _jsx("span", { children: headingIcon }), withArrowLeft && _jsx(HdArrow, { dir: "left" }), !!children && _jsx("span", { children: children }), loading ? (_jsx(Suspense, { children: _jsx(Spin, { color: theme.colors.white_1, size: "small" }) })) : (_jsxs(_Fragment, { children: [withArrowRight && _jsx(HdArrow, { dir: "right" }), trailingIcon && _jsx("span", { children: trailingIcon })] }))] })) })));
}));
Button.displayName = 'Button';
export default Button;
